import http from './ajax';
export default {
  // 用户个人信息查询
  getInfo(params) {
    return http.get('/api/user/base/info', params);
  },

  // 获取用户应用和Key列表
  getAppKeyList(params) {
    return http.get('/api/key/app_key/list', params);
  },

  // 获取用户可用api接口
  getApiList(params) {
    return http.get('/api/api/info/all', params);
  },

  logout() {
    return http.get('http://passport.fe.st.sankuai.com/account/signout');
  }

};
